import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFirebaseAuthToken } from "../../helpers/firebase_helper";
import { downloadBlob } from "../../utils/utils";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const updateEmployeeByEmployerId = createAsyncThunk(
  "employees/updateEmployeeByEmployerId",
  async ({ employerId, employeeId, data }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/employer/${employerId}/employees/${employeeId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updateIndividualById = createAsyncThunk(
  "individuals/updateIndividualById",
  async ({ individualId, data }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/individuals/${individualId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const resendIndividualInvite = createAsyncThunk(
  "individuals/resendIndividualInvite",
  async ({ individualId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/individuals/${individualId}/resend-invitation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({}),
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const deleteIndividualById = createAsyncThunk(
  "individuals/deleteIndividualById",
  async ({ individualId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/individuals/${individualId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const deleteEmployeeByEmployerId = createAsyncThunk(
  "employees/deleteEmployeeByEmployerId",
  async ({ employerId, employeeId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/employer/${employerId}/employees/${employeeId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({}),
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

// Resend employee invitation
export const resendEmployeeInvite = createAsyncThunk(
  "employees/resendEmployeeInvite",
  async ({ employerId, employeeId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/employee/${employeeId}/resend-invitation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({}),
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const editStatusEmployee = createAsyncThunk(
  "employees/editStatusEmployee",
  async ({ employerId, employeeId, status }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/employer/${employerId}/employees/${employeeId}/${status}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({}),
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

// STRIPE PAYMENT METHODS
export const sendPaymentInformation = createAsyncThunk(
  "onboarding/sendPaymentInformation",
  async (request) => {
    try {
      const firebaseToken = await getFirebaseAuthToken();
      const response = await fetch(`${API_BASE}/dashboard/payment-info`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${firebaseToken}`,
        },
        body: JSON.stringify(request),
      });
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getPaymentInformation1 = createAsyncThunk(
  "onboarding/getPaymentInformation",
  async () => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/payment-info/bank-setup-intent`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const setUpBank = createAsyncThunk(
  "onboarding/setUpBank",
  async ({ paymentMethodId }) => {
    try {
      const firebaseToken = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/payment-info/bank-setup-finish`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${firebaseToken}`,
          },
          body: JSON.stringify({ paymentMethodId }),
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const onboardingFinish = createAsyncThunk(
  "onboarding/onboardingFinish",
  async () => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/auth/onboarding/finish`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({}),
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const acceptAgreements = createAsyncThunk(
  //POST  /dashboard/auth/onboarding/agree

  "onboarding/acceptAgreements",
  async () => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/auth/onboarding/agree`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to accept agreements");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getOnboardingProgress = createAsyncThunk(
  "onboarding/getOnboardingProgress",
  async () => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(`${API_BASE}/dashboard/auth/onboarding`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getPaymentInformation = createAsyncThunk(
  "onboarding/getPaymentInformation",
  async () => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(`${API_BASE}/dashboard/payment-info`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      });
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updatePaymentInfo = createAsyncThunk(
  "onboarding/updatePaymentInfo",
  async () => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/payment-info/update-session`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updatePaymentInfoRoles = createAsyncThunk(
  "onboarding/updatePaymentInfoRoles",
  async () => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/payment-info/connect/update`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const setUpRolesPayment = createAsyncThunk(
  "onboarding/setUpRolesPayment",
  async () => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/payment-info/connect/setup`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const addDefaultPromoCode = createAsyncThunk(
  "promoCodes/addDefaultPromoCode",
  async () => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(`${API_BASE}/dashboard/promo-code/default`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({}),
      });
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);
// Invoices

export const getBillingInvoices = createAsyncThunk(
  "billing/getBillingInvoices",
  async ({ userId, page, paid }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/billing/${userId}/invoices?page=${page}&paid=${paid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getAllBillingInvoices = createAsyncThunk(
  "billing/getAllBillingInvoices",
  async ({ userId, page }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/billing/${userId}/invoices?page=${page}&paid=all`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getInvoicesOfMonth = createAsyncThunk(
  "billing/getInvoiceOfMonth",
  async ({ userId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/billing/${userId}/invoices/employees/current-month`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getInvoiceById = createAsyncThunk(
  "billing/getInvoiceById",
  async ({ userId, invoiceId, isAdmin }) => {
    try {
      const token = await getFirebaseAuthToken();
      const url = isAdmin
        ? `${API_BASE}/dashboard/admin/invoices/${invoiceId}`
        : `${API_BASE}/dashboard/billing/${userId}/invoices/${invoiceId}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      });
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const payInvoice = createAsyncThunk(
  "billing/payInvoice",
  async ({ userId, invoiceId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/billing/${userId}/invoices/${invoiceId}/pay`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({}),
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const payInvoiceNew = createAsyncThunk(
  "billing/payInvoice",
  async ({ userId, invoiceId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/payment/invoices/${invoiceId}/pay`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            employerId: userId,
          }),
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const payNextInvoice = createAsyncThunk(
  "billing/payNextInvoice",
  async ({ userId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/billing/${userId}/invoices/employees/current-month/pay`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({}),
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

// Commissions

export const getCommissions = createAsyncThunk(
  "commissions/getCommissions",
  async ({ userId, page }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/billing/${userId}/commissions?page=${page}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const getCommissionById = createAsyncThunk(
  "commissions/getCommissionById",
  async ({ userId, commissionId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/billing/${userId}/commissions/${commissionId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);
// Commissions Admin
export const getCommissionsAdmin = createAsyncThunk(
  "commissions/getCommissionsAdmin",
  async ({ paid, page, pageSize, month, role, dashboardUserId, archived }) => {
    const token = await getFirebaseAuthToken();

    // Build query params
    const params = new URLSearchParams();
    if (paid !== undefined) params.append("paid", paid);
    if (page !== undefined) params.append("page", page);
    if (pageSize !== undefined) params.append("pageSize", pageSize);
    if (month) params.append("month", month);
    if (role) params.append("role", role);
    if (dashboardUserId) params.append("dashboardUserId", dashboardUserId);
    if (archived !== undefined) params.append("archived", archived);

    const response = await fetch(
      `${API_BASE}/dashboard/admin/commissions?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      }
    );
    const res = await response.json();
    return res;
  }
);

// Admin - Archive/Unarchive Commission
export const archiveCommission = createAsyncThunk(
  "commissions/archiveCommission",
  async ({ commissionId, archived }) => {
    const token = await getFirebaseAuthToken();
    const response = await fetch(
      `${API_BASE}/dashboard/admin/commissions/${commissionId}/archive`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({ archived }),
      }
    );
    const res = await response.json();
    return res;
  }
);

// Admin - Search Users for Autocomplete
export const searchUsersAdmin = createAsyncThunk(
  "users/searchUsersAdmin",
  async ({ query, role, page, pageSize, commissionRolesOnly = true }) => {
    const token = await getFirebaseAuthToken();

    const params = new URLSearchParams();
    if (query) params.append("query", query);
    if (role) params.append("role", role);
    if (page !== undefined) params.append("page", page);
    if (pageSize !== undefined) params.append("pageSize", pageSize);
    params.append("commissionRolesOnly", commissionRolesOnly);

    const response = await fetch(
      `${API_BASE}/dashboard/admin/users/search?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      }
    );
    const res = await response.json();
    return res;
  }
);

export const getCommissionByIdAdmin = createAsyncThunk(
  "commissions/getCommissionByIdAdmin",
  async ({ commissionId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/admin/commissions/${commissionId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const payCommissionAdmin = createAsyncThunk(
  "commissions/payCommissionAdmin",
  async ({ commissionId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/admin/commissions/pay/${commissionId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({}),
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

// Use referral code

export const validateReferralCode = createAsyncThunk(
  "referral/validateReferralCode",
  async ({ code }) => {
    try {
      const response = await fetch(`${API_BASE}/dashboard/referral/${code}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const addIndividualByPromoCode = createAsyncThunk(
  "individuals/addIndividualByPromoCode",
  async ({ code, firstName, lastName, email }) => {
    try {
      const body = {
        firstName,
        lastName,
        email,
      };
      const response = await fetch(`${API_BASE}/dashboard/referral/${code}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

// Resend invitation
export const resentInvitation = createAsyncThunk(
  "individuals/resentInvitation",
  async ({ userId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/users/${userId}/resend-invitation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({}),
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

// Invite users
export const inviteUsers = createAsyncThunk(
  "individuals/inviteUsers",
  async (payload) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/users/access-invites`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        }
      );


      if (!response.ok) {
        const responseJson = await response.json();

        return {
          error: true,
          message: responseJson.error || responseJson.message,
        };
      }

      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      return {
        error: true,
        message: "An error occurred",
      };
    }
  }
);

export const validateUserAccessInvite = createAsyncThunk(
  "individuals/validateUserAccessInvite",
  async ({ inviteCode }) => {
    const token = await getFirebaseAuthToken();
    try {
      const response = await fetch(
        `${API_BASE}/dashboard/users/access-invites/validate/${inviteCode}`,
        {
          method: "GET",
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const aceptUserAccessInvitation = createAsyncThunk(
  "individuals/aceptUserAccessInvitation",
  async ({ inviteCode }) => {
    const token = await getFirebaseAuthToken();
    try {
      const response = await fetch(
        `${API_BASE}/dashboard/users/access-invites/accept/${inviteCode}`,
        {
          method: "POST",
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const declineUserAccessInvitation = createAsyncThunk(
  "individuals/declineUserAccessInvitation",
  async ({ inviteCode }) => {
    const token = await getFirebaseAuthToken();
    try {
      const response = await fetch(
        `${API_BASE}/dashboard/users/access-invites/decline/${inviteCode}`,
        {
          method: "POST",
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const resendUserAccessInvitation = createAsyncThunk(
  "individuals/resendUserAccessInvitation",
  async ({ id }, { rejectWithValue }) => {
    const token = await getFirebaseAuthToken();
    try {
      const response = await fetch(
        `${API_BASE}/dashboard/users/access-invites/${id}/resend`,
        {
          method: "POST",
          body: JSON.stringify({}),
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to resend invitation");
      }

      const res = await response.json();
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getUserAccessInviteByDashboardUserId = createAsyncThunk(
  "individuals/getUserAccessInviteByDashboardUserId",
  async () => {
    const token = await getFirebaseAuthToken();
    try {
      const response = await fetch(
        `${API_BASE}/dashboard/users/access-invites`,
        {
          method: "GET",
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getUserAccessInviteByEmail = createAsyncThunk(
  "individuals/getUserAccessInviteByEmail",
  async ({ email }) => {
    const token = await getFirebaseAuthToken();
    try {
      const response = await fetch(
        `${API_BASE}/dashboard/users/access-invites/email/${email}`,
        {
          method: "GET",
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const removeAccessInvite = createAsyncThunk(
  "individuals/removeAccessInvite",
  async (id) => {
    const token = await getFirebaseAuthToken();
    try {
      const response = await fetch(
        `${API_BASE}/dashboard/users/access-invites/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error");
      }

      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const removeUserAccessAssociation = createAsyncThunk(
  "individuals/removeUserAccessAssociation",
  async ({ invitedUserId }) => {
    const token = await getFirebaseAuthToken();
    try {
      const response = await fetch(
        `${API_BASE}/dashboard/users/access-associations/${invitedUserId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);


// Delete user
export const deleteUser = createAsyncThunk(
  "individuals/deleteUser",
  async ({ userId }) => {
    const token = await getFirebaseAuthToken();
    try {
      const response = await fetch(`${API_BASE}/dashboard/users/${userId}`, {
        method: "DELETE",
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      });
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

// Reports
export const getReports = createAsyncThunk(
  "reports/getReports",
  async ({ userId, page = 0, pageSize = 10 }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/billing/${userId}/reports?page=${page}&pageSize=${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const getReportById = createAsyncThunk(
  "reports/getReportById",
  async ({ userId, reportId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/billing/${userId}/reports/${reportId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const getReportByInvoiceId = createAsyncThunk(
  "reports/getReportByInvoiceId",
  async ({ userId, invoiceId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/billing/${userId}/invoices/${invoiceId}/report`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

// Download entity-specific reports (brokers, employers, employees)
export const downloadEntityReport = createAsyncThunk(
  "reports/downloadEntityReport",
  async ({ dashboardUserId, reportType }) => {
    const token = await getFirebaseAuthToken();
    const response = await fetch(
      `${API_BASE}/dashboard/reports/by-user/${dashboardUserId}/${reportType}`,
      {
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download report");
    }

    const blob = await response.blob();
    return { blob, reportType };
  }
);

// Download GAs Report by Dashboard User ID (Admin only, for National profiles)
export const downloadGAsReportByUserId = createAsyncThunk(
  "reports/downloadGAsReportByUserId",
  async ({ dashboardUserId }) => {
    const token = await getFirebaseAuthToken();
    const response = await fetch(
      `${API_BASE}/dashboard/reports/by-user/${dashboardUserId}/gas`,
      {
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download GAs report");
    }

    const blob = await response.blob();
    downloadBlob(blob, "GAs_report.csv");
    return response;
  }
);

// Download Brokers Report by Dashboard User ID
export const downloadBrokersReportByUserId = createAsyncThunk(
  "reports/downloadBrokersReportByUserId",
  async ({ dashboardUserId }) => {
    const token = await getFirebaseAuthToken();
    const response = await fetch(
      `${API_BASE}/dashboard/reports/by-user/${dashboardUserId}/brokers`,
      {
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download brokers report");
    }

    const blob = await response.blob();
    downloadBlob(blob, "Brokers_report.csv");
    return response;
  }
);

// Download Employers Report by Dashboard User ID
export const downloadEmployersReportByUserId = createAsyncThunk(
  "reports/downloadEmployersReportByUserId",
  async ({ dashboardUserId }) => {
    const token = await getFirebaseAuthToken();
    const response = await fetch(
      `${API_BASE}/dashboard/reports/by-user/${dashboardUserId}/employers`,
      {
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download employers report");
    }

    const blob = await response.blob();
    downloadBlob(blob, "Employers_report.csv");
    return response;
  }
);

// Download Employees Report by Dashboard User ID
export const downloadEmployeesReportByUserId = createAsyncThunk(
  "reports/downloadEmployeesReportByUserId",
  async ({ dashboardUserId }) => {
    const token = await getFirebaseAuthToken();
    const response = await fetch(
      `${API_BASE}/dashboard/reports/by-user/${dashboardUserId}/employees`,
      {
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download employees report");
    }

    const blob = await response.blob();
    downloadBlob(blob, "Employees_report.csv");
    return response;
  }
);

// Admin - Refund Invoice (supports full and partial refunds)
// Full refund: no amount or amount = null
// Partial refund: amount in cents (e.g., 5000 = $50.00)
export const refundInvoice = createAsyncThunk(
  "billing/refundInvoice",
  async ({ invoiceId, amount }) => {
    try {
      const token = await getFirebaseAuthToken();
      const body = amount != null ? { amount } : {};
      const response = await fetch(
        `${API_BASE}/dashboard/admin/invoices/${invoiceId}/refund`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(body),
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);